module.exports = __webpack_public_path__ + "images/recommendations.d01db5b671ed4ae9fd8dd1537717db8d.svg";